"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../../common/Modal/Modal"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./RemoveApiKeyModal.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var removeApiKeyModalClasses = (0, _cssClassesHelper.getBEMClasses)('remove-api-key-modal');
var RemoveApiKeyModal = function RemoveApiKeyModal(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: props.isOpen,
    title: t("Delete API Key"),
    customClass: "retail-api-keys-modal-delete",
    close: props.close,
    footer: {
      buttonText: t("Delete"),
      buttonStyle: 'subtractive',
      onClick: function onClick() {
        return props.removeApiKey(props.apiKey);
      }
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: removeApiKeyModalClasses('text')
  }, t("Are you sure you want to delete this API Key?")));
};
RemoveApiKeyModal.propTypes = {
  isOpen: _propTypes["default"].bool.isRequired,
  apiKey: _propTypes["default"].string,
  removeApiKey: _propTypes["default"].func.isRequired,
  close: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = RemoveApiKeyModal;